import { Validator } from '@vista-digital/validator';
/**
 * Defines what identifier is used for Loyalty Members.
 */
export var LoyaltyMemberIdentifier;
(function (LoyaltyMemberIdentifier) {
    LoyaltyMemberIdentifier["Username"] = "Username";
    LoyaltyMemberIdentifier["Email"] = "Email";
})(LoyaltyMemberIdentifier || (LoyaltyMemberIdentifier = {}));
export const loyaltyMemberIdentifierValidator = Validator.oneOf(Object.values(LoyaltyMemberIdentifier));
//# sourceMappingURL=loyalty-member-identifier.js.map